module.exports = __webpack_public_path__ + "static/featured-download-colors-918cd3c414f3b6f5ee7da5100855308f.png";